<script>
  import { onMount } from "svelte"
  import { flatenObject } from "../../../../../../Script/flatenObject"

  export let jsonData = []
  console.log({ jsonData })

  let headers = []
  let displayHeaders = []
  let rows = []

  const capitalize = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : "")

  const formatDate = (value) => {
    if (!value) return ""

    const d = new Date(value)
    if (Number.isNaN(d.getTime())) return value

    const dd = String(d.getDate()).padStart(2, "0")
    const mm = String(d.getMonth() + 1).padStart(2, "0")
    const yyyy = d.getFullYear()

    return `${dd}-${mm}-${yyyy}`
  }
  // const buildTable = () => {
  //   if (!jsonData.length) return

  //   headers = []
  //   displayHeaders = []
  //   rows = []

  //   const firstRow = jsonData[0]

  //   /* -------- METADATA -------- */
  //   const flatMeta = flatenObject(firstRow.metadata ?? {})
  //   for (const key in flatMeta) {
  //     headers.push(key)
  //     displayHeaders.push(capitalize(key))
  //   }

  //   /* -------- OPTIONS (EXCEPT EMAIL) -------- */
  //   const optionKeys = Object.keys(firstRow.options ?? {}).filter((k) => k !== "email")

  //   optionKeys.forEach((key) => {
  //     headers.push(key)
  //     displayHeaders.push(capitalize(key))
  //   })

  //   /* -------- FILE KEYS (RAW KEYS ONLY) -------- */
  //   const fileKeySet = new Set()

  //   jsonData.forEach((row) => {
  //     Object.keys(row.files ?? {}).forEach((key) => {
  //       fileKeySet.add(key) // ✅ DO NOT decorate here
  //     })
  //   })

  //   const fileKeys = Array.from(fileKeySet).sort()

  //   fileKeys.forEach((key) => {
  //     headers.push(key)
  //     displayHeaders.push(`${capitalize(key)} ( with Filetype eg: .jpg, .jpeg, .png)`)
  //   })

  //   /* -------- EMAIL (ALWAYS LAST) -------- */
  //   if (firstRow.options?.email !== undefined) {
  //     headers.push("email")
  //     displayHeaders.push("Email")
  //   }

  //   /* -------- ROW DATA -------- */
  //   jsonData.forEach((row) => {
  //     const flatRow = {}

  //     // metadata
  //     const rowMeta = flatenObject(row.metadata ?? {})
  //     for (const key in rowMeta) {
  //       flatRow[key] = rowMeta[key]
  //     }

  //     // options
  //     optionKeys.forEach((key) => {
  //       if (key === "expireOn") {
  //         flatRow[key] = formatDate(row.options?.[key])
  //       } else {
  //         flatRow[key] = row.options?.[key] ?? ""
  //       }
  //     })

  //     // files (RAW key lookup works now ✅)
  //     fileKeys.forEach((key) => {
  //       flatRow[key] = row.files?.[key] ?? ""
  //     })

  //     // email
  //     flatRow.email = row.options?.email ?? ""

  //     const orderedRow = []
  //     headers.forEach((h) => {
  //       orderedRow.push(flatRow[h] ?? "")
  //     })

  //     rows.push(orderedRow)
  //   })
  // }

  // const buildTable = () => {
  //   if (!jsonData.length) return

  //   headers = []
  //   displayHeaders = []
  //   rows = []

  //   const firstRow = jsonData[0]

  //   /* -------- METADATA -------- */
  //   const flatMeta = flatenObject(firstRow.metadata ?? {})
  //   for (const key in flatMeta) {
  //     headers.push(key)
  //     displayHeaders.push(capitalize(key))
  //   }

  //   /* -------- OPTIONS (EXCEPT EMAIL) -------- */
  //   const optionKeys = Object.keys(firstRow.options ?? {}).filter((k) => k !== "email")

  //   optionKeys.forEach((key) => {
  //     headers.push(key)
  //     displayHeaders.push(capitalize(key))
  //   })

  //   /* -------- FILE KEYS (ALL ROWS) -------- */
  //   const fileKeySet = new Set()

  //   // jsonData.forEach((row) => {
  //   //   Object.keys(row.files ?? {}).forEach((key) => {
  //   //     fileKeySet.add(key)
  //   //   })
  //   // })
  //   jsonData.forEach((row) => {
  //     Object.keys(row.files ?? {}).forEach((key) => {
  //       const displayKey = `${key} (Filename with Filetype eg: .jpg, .jpeg, .png)`
  //       fileKeySet.add(displayKey)
  //     })
  //   })

  //   const fileKeys = Array.from(fileKeySet).sort()

  //   fileKeys.forEach((key) => {
  //     headers.push(key)
  //     displayHeaders.push(capitalize(key))
  //   })

  //   /* -------- EMAIL (ALWAYS LAST) -------- */
  //   if (firstRow.options?.email !== undefined) {
  //     headers.push("email")
  //     displayHeaders.push("Email")
  //   }

  //   /* -------- ROW DATA -------- */
  //   jsonData.forEach((row) => {
  //     const flatRow = {}

  //     // metadata
  //     const rowMeta = flatenObject(row.metadata ?? {})
  //     for (const key in rowMeta) {
  //       flatRow[key] = rowMeta[key]
  //     }

  //     // options (expireOn formatted)
  //     optionKeys.forEach((key) => {
  //       if (key === "expireOn") {
  //         flatRow[key] = formatDate(row.options?.[key])
  //       } else {
  //         flatRow[key] = row.options?.[key] ?? ""
  //       }
  //     })

  //     // files
  //     fileKeys.forEach((key) => {
  //       flatRow[key] = row.files?.[key] ?? ""
  //     })

  //     // email last
  //     flatRow.email = row.options?.email ?? ""

  //     const orderedRow = []
  //     headers.forEach((h) => {
  //       orderedRow.push(flatRow[h] ?? "")
  //     })

  //     rows.push(orderedRow)
  //   })
  // }
  const buildTable = () => {
    if (!jsonData?.length) return

    headers = []
    displayHeaders = []
    rows = []

    const firstRow = jsonData[0]

    /* =============================
     * 1. FILENAME (FIRST IF EXISTS)
     * ============================= */
    if (firstRow.files?.filename !== undefined) {
      headers.push("filename")
      displayHeaders.push("Filename (with Filetype eg: .jpg, .jpeg, .png)")
    }

    /* =============================
     * 2. METADATA (FLATTENED)
     * ============================= */
    const flatMeta = flatenObject(firstRow.metadata ?? {})
    Object.keys(flatMeta).forEach((key) => {
      headers.push(key)
      displayHeaders.push(capitalize(key))
    })

    /* =============================
     * 3. OPTIONS (EXCEPT EMAIL)
     * ============================= */
    const optionKeys = Object.keys(firstRow.options ?? {}).filter((k) => k !== "email")

    optionKeys.forEach((key) => {
      headers.push(key)
      displayHeaders.push(capitalize(key))
    })

    /* =============================
     * 4. FILE KEYS (image-1, image-2…)
     * ============================= */
    const fileKeySet = new Set()

    jsonData.forEach((row) => {
      Object.keys(row.files ?? {}).forEach((key) => {
        if (key !== "filename") {
          fileKeySet.add(key)
        }
      })
    })

    const fileKeys = Array.from(fileKeySet).sort()

    fileKeys.forEach((key) => {
      headers.push(key)
      displayHeaders.push(`${capitalize(key)} (Filename with Filetype eg: .jpg, .jpeg, .png)`)
    })

    /* =============================
     * 5. EMAIL (ALWAYS LAST)
     * ============================= */
    if (firstRow.options?.email !== undefined) {
      headers.push("email")
      displayHeaders.push("Email")
    }

    /* =============================
     * 6. ROW DATA
     * ============================= */
    jsonData.forEach((row) => {
      const flatRow = {}

      // filename
      if (headers.includes("filename")) {
        flatRow.filename = row.files?.filename ?? ""
      }

      // metadata
      const rowMeta = flatenObject(row.metadata ?? {})
      Object.keys(rowMeta).forEach((key) => {
        flatRow[key] = rowMeta[key]
      })

      // options
      optionKeys.forEach((key) => {
        if (key === "expireOn") {
          flatRow[key] = formatDate(row.options?.expireOn)
        } else {
          flatRow[key] = row.options?.[key] ?? ""
        }
      })

      // files (image-1, image-2…)
      fileKeys.forEach((key) => {
        flatRow[key] = row.files?.[key] ?? ""
      })

      // email
      flatRow.email = row.options?.email ?? ""

      // strict ordered row
      rows.push(headers.map((h) => flatRow[h] ?? ""))
    })
  }

  onMount(buildTable)
</script>

<div class="px-4 sm:px-6 lg:px-8">
  <div class="flow-root">
    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle">
        <table class="relative min-w-full divide-y divide-gray-300 dark:divide-gray-700">
          <thead class="sticky top-0 z-10 bg-[#f7f7f7] dark:bg-bodyblack">
            <tr>
              {#each displayHeaders as header, i}
                <th class="truncate py-3.5 text-left text-sm font-semibold text-gray-900 first:pl-3 last:pr-3 dark:text-gray-200 {i === 0 ? 'w-[20%] pl-4 pr-3 sm:pl-0' : 'w-[10%] px-3'}">
                  {header}
                </th>
              {/each}
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-200 bg-white dark:divide-gray-700 dark:bg-transparent">
            {#each rows as row}
              <tr class="hover:bg-gray-50 dark:hover:bg-gray-800">
                {#each row as cell, i}
                  <td title={cell} class="truncate py-3 text-sm first:pl-3 last:pr-3 {i === 0 ? 'w-[20%] pl-4 pr-3 font-medium text-gray-900 dark:text-gray-200 sm:pl-0' : 'w-[10%] px-3 text-gray-500 dark:text-gray-300'}">
                    {cell || "-"}
                  </td>
                {/each}
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
